var map = {
	"./ai-magix-logo.png": 202,
	"./banner-bg.png": 8469,
	"./book-a-demo-bg.png": 5210,
	"./call.png": 6395,
	"./client-1.png": 5172,
	"./client-10.png": 6910,
	"./client-11.png": 5223,
	"./client-12.png": 5164,
	"./client-13.png": 4261,
	"./client-14.png": 7754,
	"./client-15.png": 5331,
	"./client-16.png": 56,
	"./client-17.png": 7921,
	"./client-18.png": 5990,
	"./client-19.png": 2319,
	"./client-2.png": 447,
	"./client-20.png": 5375,
	"./client-3.png": 6646,
	"./client-4.png": 6617,
	"./client-5.png": 2416,
	"./client-6.png": 9979,
	"./client-7.png": 8434,
	"./client-8.png": 7589,
	"./client-9.png": 5964,
	"./computer-vision.png": 1631,
	"./get-started-bg.png": 9547,
	"./green-tick.png": 6078,
	"./landscape-1.png": 4682,
	"./landscape-2.png": 4849,
	"./landscape-3.png": 6984,
	"./linkedin.png": 5405,
	"./mail.png": 5046,
	"./manufacturing-sop.png": 44,
	"./orange-tick.png": 1143,
	"./seamless-gradient.png": 3901,
	"./star.png": 6035,
	"./success-msg.png": 6574,
	"./testimonials.png": 2495,
	"./triangle-patterm.png": 793,
	"./why-inspection-one.png": 2829
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;